<template>
  <img style="width: auto;height: 100%" :src=fileDate.url />
  <div class="confirmDiv">
    <el-input v-model="fileDate.fileName" :disabled="inputStatus" placeholder="请输入图纸番号"></el-input>
    <div class="marginTop">
      <el-button type="primary" @click="editButton">{{editText}}</el-button>
      <el-button type="success" :disabled="updateStatus" @click="updateButton">确认</el-button>
    </div>
    <div class="marginTop">
      <el-button type="primary" icon="el-icon-arrow-left" @click="prevPage">上一页</el-button>
      <el-button type="primary" @click="nextPage">下一页 <el-icon class="el-icon--right"><el-icon-arrow-right/></el-icon> </el-button>
    </div>
  </div>

</template>

<script>
export default {
  name: "UploadFileConfirm",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      fileDate: {},
      editText: '编辑',
      inputStatus: true,
      updateStatus: true,
      currentSub: 0
    }
  },
  methods:{
    async updateButton() {
      let {data: res} = await this.$axios.post('bus/fileStorage/updateFileData', this.fileDate);
      if(res.code !== 0){
        this.$message.error('修改番号失败：' + res.message)
        return;
      }
      this.$message.success("修改成功")
    },

    editButton(){
      this.inputStatus = !this.inputStatus
      this.updateStatus = !this.updateStatus
      if (!this.inputStatus){
        this.editText = "取消编辑"
      }else {
        this.editText = "编辑"
      }
    },

    prevPage(){
      if (this.currentSub-1 <0){
        this.$message.error("当前已经是第一页了，不能再上一页了。")
      }else {
        this.currentSub--
        this.fileDate = this.parentData.fileList[this.currentSub]
        this.updateStatus = true
        this.inputStatus =  true
      }
    },

    nextPage(){
      if (this.currentSub+1 >= this.parentData.fileList.length){
        this.$message.error("当前已经是最后一页了，不能再下一页了。")
      }else {
        this.currentSub++
        this.fileDate = this.parentData.fileList[this.currentSub]
        this.updateStatus = true
        this.inputStatus =  true
      }
    }
  },
  created() {
    this.fileDate = this.parentData.fileList[this.currentSub]
  }
}
</script>

<style scoped>
.marginTop{
  margin-top: 10px;
}
.confirmDiv{
  width: 25%;
  height: 120px;
  position: absolute;
  bottom: 5%;
  left: 72%;
}
</style>
